// extracted by mini-css-extract-plugin
export default {"section":"MyUpcomingMatchesSection_section__ucWdj","title":"MyUpcomingMatchesSection_title__ykbTs","list":"MyUpcomingMatchesSection_list__1H7Jw"};